import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import ReactCountryFlag from 'react-country-flag';

const translations = {
  en: {
    nav: {
      home: 'Home',
      features: 'Features',
      howItWorks: 'How It Works',
      getStarted: 'Get Started'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      features: 'المميزات',
      howItWorks: 'كيف يعمل',
      getStarted: 'ابدأ الآن'
    }
  }
};

const Header = () => {
  const { language, toggleLanguage, isRTL } = useLanguage();
  const t = translations[language];
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white/95 backdrop-blur-md shadow-sm sticky top-0 z-50" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center">
            <a href="#" className="text-2xl md:text-3xl font-bold text-primary flex items-center whitespace-nowrap gap-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
              <span className="text-3xl">🍳</span>
              <span>Chaiffy</span>
            </a>
          </div>

          <nav className="hidden lg:flex items-center gap-8">
            <a href="#" className="text-gray-600 hover:text-primary transition-colors duration-200 font-medium text-base">{t.nav.home}</a>
            <a href="#features" className="text-gray-600 hover:text-primary transition-colors duration-200 font-medium text-base">{t.nav.features}</a>
            <a href="#how-it-works" className="text-gray-600 hover:text-primary transition-colors duration-200 font-medium text-base">{t.nav.howItWorks}</a>
          </nav>

          <div className="flex items-center gap-3">
            <button 
              onClick={toggleLanguage}
              className="flex items-center gap-2 px-4 py-2.5 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-xl transition-all duration-200"
            >
              <ReactCountryFlag
                countryCode={language === 'en' ? 'GB' : 'SA'}
                svg
                style={{ width: '20px', height: '20px' }}
                title={language === 'en' ? 'English' : 'العربية'}
              />
              <span className="text-sm font-semibold text-gray-700 hidden sm:inline">{language === 'en' ? 'EN' : 'AR'}</span>
            </button>

            <a 
              href="/start"
              className="hidden sm:inline-block px-6 py-2.5 bg-gradient-green text-white rounded-xl hover:opacity-90 transition-all duration-200 font-bold text-base shadow-md hover:shadow-lg transform hover:-translate-y-0.5 whitespace-nowrap"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t.nav.getStarted}
            </a>

            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden p-2 text-gray-600 hover:text-primary"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden pb-4 border-t border-gray-100 animate-fade-in">
            <nav className="flex flex-col gap-3 pt-4">
              <a href="#" onClick={() => setMobileMenuOpen(false)} className="text-gray-600 hover:text-primary transition-colors font-medium py-2">{t.nav.home}</a>
              <a href="#features" onClick={() => setMobileMenuOpen(false)} className="text-gray-600 hover:text-primary transition-colors font-medium py-2">{t.nav.features}</a>
              <a href="#how-it-works" onClick={() => setMobileMenuOpen(false)} className="text-gray-600 hover:text-primary transition-colors font-medium py-2">{t.nav.howItWorks}</a>
              <a 
                href="/start"
                className="sm:hidden inline-block px-6 py-3 bg-gradient-green text-white rounded-xl font-bold text-center mt-2"
              >
                {t.nav.getStarted}
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
